export const INITIAL_LOAD = 'INITIAL_LOAD';

export const WORKOUT_TILE_DATA_REQUEST = 'WORKOUT_TILE_DATA_REQUEST';
export const WORKOUT_TILE_DATA_SUCCESS = 'WORKOUT_TILE_DATA_SUCCESS';
export const WORKOUT_TILE_DATA_FAILURE = 'WORKOUT_TILE_DATA_FAILURE';


export const BOOKING_FROM_DASHBOARD = 'book_start_from_dash';

export const BOOKING_DASH_TILE_SELECTED = 'dashboard_workouttile_selected';
export const NEXT_BOOKING_DASH_TILE_SELECTED = 'dashboard_nextbookingtile_selected';
export const NUTRITION_DASH_TILE_SELECTED = 'dashboard_nutritiontile_selected';

export const WEEKLY_GOAL_DATA_REQUEST = 'WEEKLY_GOAL_DATA_REQUEST';
export const WEEKLY_GOAL_DATA_SUCCESS = 'WEEKLY_GOAL_DATA_SUCCESS';
export const WEEKLY_GOAL_DATA_FAILURE = 'WEEKLY_GOAL_DATA_FAILURE';

export const DASHBOARD_OPENED_REQUEST = 'DASHBOARD_OPENED_REQUEST';
export const DASHBOARD_OPENED_SUCCESS = 'DASHBOARD_OPENED_SUCCESS';
export const DASHBOARD_OPENED_FAILURE = 'DASHBOARD_OPENED_FAILURE';

export const DASHBOARD_BLOG_INSIGHTS_REQUEST = 'DASHBOARD_BLOG_INSIGHTS_REQUEST';
export const DASHBOARD_BLOG_INSIGHTS_SUCCESS = 'DASHBOARD_BLOG_INSIGHTS_SUCCESS';
export const DASHBOARD_BLOG_INSIGHTS_FAILURE = 'DASHBOARD_BLOG_INSIGHTS_FAILURE';

export const ALL_DASHBOARD_BLOG_INSIGHTS_REQUEST = 'ALL_DASHBOARD_BLOG_INSIGHTS_REQUEST';
export const ALL_DASHBOARD_BLOG_INSIGHTS_SUCCESS = 'ALL_DASHBOARD_BLOG_INSIGHTS_SUCCESS';
export const ALL_DASHBOARD_BLOG_INSIGHTS_FAILURE = 'ALL_DASHBOARD_BLOG_INSIGHTS_FAILURE';

export const ALL_DASHBOARD_BLOG_HELP_REQUEST = 'ALL_DASHBOARD_BLOG_HELP_REQUEST';
export const ALL_DASHBOARD_BLOG_HELP_SUCCESS = 'ALL_DASHBOARD_BLOG_HELP_SUCCESS';
export const ALL_DASHBOARD_BLOG_HELP_FAILURE = 'ALL_DASHBOARD_BLOG_HELP_FAILURE';

export const DASHBOARD_BLOG_CARD_PRESSED = 'dashboard_blog_card_pressed';

export const WEIGHT_TARGET_AND_MILESTONE_REQUEST = 'WEIGHT_TARGET_AND_MILESTONE_REQUEST';
export const WEIGHT_TARGET_AND_MILESTONE_SUCCESS = 'WEIGHT_TARGET_AND_MILESTONE_SUCCESS';
export const WEIGHT_TARGET_AND_MILESTONE_FAILURE = 'WEIGHT_TARGET_AND_MILESTONE_FAILURE';

export const USER_GOAL_CHANGED = 'USER_GOAL_CHANGED';

export const OPEN_LEADERBOARD_MODAL = 'OPEN_LEADERBOARD_MODAL';
export const CLOSE_LEADERBOARD_MODAL = 'CLOSE_LEADERBOARD_MODAL';
export const SELECT_TEAM = 'SELECT_TEAM';
export const JOIN_LEADERBOARD_REQUEST = 'JOIN_LEADERBOARD_REQUEST';
export const JOIN_LEADERBOARD_SUCCESS = 'JOIN_LEADERBOARD_SUCCESS';
export const JOIN_LEADERBOARD_FAILURE = 'JOIN_LEADERBOARD_FAILURE';
export const SHOW_TEAM_SELECT_SCREEN = 'SHOW_TEAM_SELECT_SCREEN';
export const SEE_ALL_LEADERBOARDS = 'SEE_ALL_LEADERBOARDS';
